import Empty from 'constants/empty';

export const mailingPreferencesSelector = store => store.mailingPreferences || Empty.Object;
